// extracted by mini-css-extract-plugin
export default {"pos-center":"LoadingSpinner_pos-center__lX7X4","loader":"LoadingSpinner_loader__WLc6S","spin":"LoadingSpinner_spin__xGBLj"};